<template>
  <div class="error w-full" id="error-401">
    <div class="p-grid p-jc-center p-ai-center">
      <div class="p-col">
        <SnippyError />
      </div>
      <div class="p-col-7">
        <h1 class="big-title mb-0">
          Erreur 401
        </h1>
        <h2 class="text-3xl">Accès refusé !</h2>
        <p>
          Vous n'êtes pas autorisé à voir cette page.
        </p>
        <router-link to="/">
          <Button label="Retour à l'accueil" class="btn-purple mt-5" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import SnippyError from "~/components/Extra/SnippyError.vue";

export default {
  components: {
    SnippyError,
  },
};
</script>
